
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="connectSftp()">Connect SFTP</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="createSftp()">Create SFTP</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
            </div>
		    <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Host</th>
								<th>Username</th>
                                <th>Sync Status</th>
                                <th>Sync Enabled</th>
                                <th>Changed At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:25%;">{{ row.sftpConfig?.client?.host }}</td>
								<td style="width:20%;">{{ row.sftpConfig?.client?.username }}</td>
                                <td style="width:12%;">{{ row.syncStatus }}</td>
                                <td style="width:10%;">{{ row.syncEnabled }}</td>
                                <td style="width:13%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
                                <td style="width:20%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Sync" class="btn-link" style="cursor: pointer;" (click)="sync(row)">Sync</span> |
                                    <span title="School Mapping" class="btn-link" style="cursor: pointer;" (click)="schoolMapping(row)">School Mapping</span> |
                                    <span title="Remove" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="removeSftp(row)"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    